import React, { useEffect, useRef, useState } from "react";
import { FaRegHeart, FaHeart } from "react-icons/fa";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { CustomeStyle } from "../../Css/CustomeStyle";
import Footer from "../../Fotter";
import { useDispatch, useSelector } from "react-redux";
import { GetSubCategory } from "../../redux/slices/GetSubCategorySlice";
import { toast } from "react-toastify";
import { viewCartData } from "../../redux/slices/ViewCartSlice";
import { AddToCart } from "../../redux/slices/AddTocartSlice";
import { FiShoppingCart } from "react-icons/fi";
import { MdFilterList, MdArrowDropDown } from "react-icons/md";
import { GetCategorySubCate } from "../../redux/slices/GetCategorySubCateSlice";
import { AddWishlist } from "../../redux/slices/AddWishlistSlice";
import { AiOutlineArrowLeft } from "react-icons/ai";
function ShowSubCategory() {
  const navigate = useNavigate();
  const sidebarRef = useRef(null);
  const dispatch = useDispatch();
  const [likedProducts, setLikedProducts] = useState(new Set());
  const [isSidebarVisible1, setIsSidebarVisible1] = useState(false);
  const { AllSubCategory } = useSelector((state) => state.subCategory);
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Default Sorting");
  const { SubCategory } = useSelector((state) => state.getCategorySub);
  const { state } = useLocation();
  const locationCategory =
    state?.activeCategory || localStorage.getItem("activeCategory");
  const { name, activeCategoryId } = state || {};
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    dispatch(GetCategorySubCate(activeCategoryId));
    dispatch(GetSubCategory(name))
      .unwrap()
      .finally(() => setLoading(false));
  }, [activeCategoryId, locationCategory, name, dispatch]);

  const toggleLike = (productId) => {
    dispatch(AddWishlist(productId));
    setLikedProducts((prevLikedProducts) => {
      const updatedLikes = new Set(prevLikedProducts);
      if (updatedLikes.has(productId)) {
        updatedLikes.delete(productId);
      } else {
        updatedLikes.add(productId);
      }
      return updatedLikes;
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsSidebarVisible1(false);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleAddToCart = (item) => {
    const cartData = {
      productId: item?._id,
      quantity: 1,
    };

    dispatch(AddToCart(cartData))
      .then(() => {
        dispatch(viewCartData());
        toast.success("Product added to cart!", {
          position: "top-right",
          autoClose: 2000,
          style: {
            backgroundColor: "#d0d3d4 ",
            color: "black",
            fontWeight: "bold",
          },
        });
      })
      .catch((error) => {
        console.error("Error adding to cart:", error);
      });
  };

  const options = [
    "Default Sorting",
    "Sort by price: low to high",
    "Sort by price: high to low",
    "Sort by latest",
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsSidebarVisible1(false);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsSidebarVisible1(false);
  };

  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setIsSidebarVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const _handleGo = (name) => {
    dispatch(GetSubCategory(name));
    navigate(`/category/${locationCategory}/${name}`);
  };

  const generateSlug = (text) => {
    if (!text) {
      return "";
    }
    return text
      .toLowerCase()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

  useEffect(() => {
    const script1 = document.createElement("script");
    script1.src = "https://www.googletagmanager.com/gtag/js?id=AW-16647750621";
    script1.async = true;
    document.head.appendChild(script1);

    script1.onload = () => {
      const script2 = document.createElement("script");
      script2.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-16647750621');
        `;
      document.head.appendChild(script2);
    };

    return () => {
      const scripts = document.querySelectorAll(
        'script[src="https://www.googletagmanager.com/gtag/js?id=AW-16647750621"]'
      );
      scripts.forEach((script) => script.remove());
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 ">
      <div className="flex items-center sm:p-3  sm:ms-14 px-3 ">
        <button
          onClick={() => navigate(-1)}
          className="mr-2 bg-gray-200 px-2 py-2  rounded-full flex items-center "
        >
          <AiOutlineArrowLeft className="text-lg mr-1" />
        </button>

        <h2 className="text-xl font-bold mt-6">{locationCategory}</h2>
      </div>
      <div className="flex justify-center w-[90%] mx-auto">
        <div className="overflow-x-auto">
          <div className="flex items-center justify-center gap-8 p-2 min-w-max">
            {SubCategory?.map((subcategory, index) => (
              <div
                key={index}
                onClick={() => _handleGo(subcategory.name)}
                className="flex-shrink-0 flex flex-col items-center cursor-pointer"
              >
                <div className="flex items-center justify-center w-36 h-12 rounded-3xl bg-gray-300">
                  <p className="text-center font-medium text-black px-2 line-clamp-1 mt-3">
                    {subcategory.name}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div
        className="mx-[5%] md:hidden z-50 mt-[3%] bg-gray-200 flex flex-row justify-between
       px-2 items-center rounded"
      >
        <button
          className="px-4 py-2  flex flex-row gap-1"
          onClick={() => {
            setIsSidebarVisible(!isSidebarVisible);
            setIsSidebarVisible1(false);
          }}
        >
          <MdFilterList size={24} className="text-gray-700" />
          <div className="text-gray-700 font-bold">Filter</div>
        </button>
        <div className="relative inline-block text-left ">
          <button
            className="px-4 py-2 m-2 flex flex-row bg-white rounded-2xl border border-gray-300 shadow-sm"
            onClick={() => setIsSidebarVisible1(!isSidebarVisible1)}
          >
            <div className="text-gray-700 font-bold truncate">
              {selectedOption}
            </div>
            <MdArrowDropDown className="text-gray-500 ml-2" size={24} />
          </button>

          {isSidebarVisible1 && (
            <div className="z-10 absolute mt-2 bg-white rounded-lg shadow-lg border border-gray-200 w-60">
              {options.map((option, index) => (
                <div
                  key={index}
                  onClick={() => handleOptionClick(option)}
                  className="px-4 py-2 text-black hover:bg-gray-100 cursor-pointer"
                >
                  {option}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="w-[90%] mx-auto flex flex-col md:flex-row gap-8 justify-center mb-[3%] mt-3">
        <div className="w-full sm:w-[95%] md:w-[100%]">
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-1 lg:gap-3">
            {/* {AllSubCategory?.data?.length > 0 ? (
              AllSubCategory?.data?.map((item) => {
                return (
                  <div
                    key={item._id}
                    className="bg-white shadow rounded-md overflow-hidden relative  border border-gray-200 sm:px-5 sm:py-2  px-4 py-2 "
                  >
                    <img
                      src={item?.images[0]}
                      alt={item.name}
                      className="w-full h-20 sm:h-40 object-contain bg-light  rounded-x "
                    />
                    <button
                      className="like-btn absolute top-2 left-2"
                      onClick={() => toggleLike(item._id)}
                    >
                      {likedProducts.has(item._id) ? (
                        <FaHeart
                          size="24px"
                          className="text-red-500 sm:text-lg text-xs"
                        />
                      ) : (
                        <FaRegHeart
                          size="24px"
                          className="text-gray-400 sm:text-lg md:text-xs"
                        />
                      )}
                    </button>
                    <button
                      onClick={() => handleAddToCart(item)}
                      className="like-btn absolute top-2 right-2 px-2 py-2 bg-gray-100 text-white rounded-lg hover:bg-green-50"
                    >
                      <FiShoppingCart className="text-black sm:text-base md:text-xl lg:text-2xl" />
                    </button>

                    <Link
                      to={`/category/${
                        item?.category ? generateSlug(item?.category) : "-"
                      }/${generateSlug(item?.title)}/${generateSlug(
                        item?._id
                      )}`}
                      state={{ item }}
                      className="block"
                    >
                      <div className="  ">
                        <h2 className="sm:text-xl text-xs text-black  from-neutral-600 sm:mt-0 mt-3">
                          {item.name}
                        </h2>
                        <h2
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          className={CustomeStyle.title}
                        >
                          {item.title}
                        </h2>
                        <div className="">
                          <span className={CustomeStyle.description}>
                            {item.description}
                          </span>
                        </div>
                        <div className="mt-2 flex justify-between items-center me-2">
                          <div className={`${CustomeStyle.row} space-x-1`}>
                            <span className={CustomeStyle.text}>
                              ₹{item.salePrice}
                            </span>
                            <span
                              className={CustomeStyle.text}
                              style={{ textDecoration: "line-through" }}
                            >
                              ₹{item.regularPrice}
                            </span>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                );
              })
            ) : (
              <div className="flex justify-center items-center h-[200px] w-full sm:ms-96 ms-20">
                <p className="text-center text-lg font-semibold">
                  No Product Found
                </p>
              </div>
            )} */}
            {loading ? (
              <div className="flex justify-center items-center h-[200px] w-full">
                <p className="text-center text-lg font-semibold">Loading...</p>
              </div>
            ) : AllSubCategory?.data?.length > 0 ? (
              AllSubCategory.data.map((item) => (
                <div
                  key={item._id}
                  className="bg-white shadow rounded-md overflow-hidden relative border border-gray-200 sm:px-5 sm:py-2 px-4 py-2"
                >
                  <img
                    src={item?.images[0]}
                    alt={item.name}
                    className="w-full h-20 sm:h-40 object-contain bg-light rounded-x"
                  />
                  <button
                    className="like-btn absolute top-2 left-2"
                    onClick={() => toggleLike(item._id)}
                  >
                    {likedProducts.has(item._id) ? (
                      <FaHeart
                        size="24px"
                        className="text-red-500 sm:text-lg text-xs"
                      />
                    ) : (
                      <FaRegHeart
                        size="24px"
                        className="text-gray-400 sm:text-lg md:text-xs"
                      />
                    )}
                  </button>
                  <button
                    onClick={() => handleAddToCart(item)}
                    className="like-btn absolute top-2 right-2 px-2 py-2 bg-gray-100 text-white rounded-lg hover:bg-green-50"
                  >
                    <FiShoppingCart className="text-black sm:text-base md:text-xl lg:text-2xl" />
                  </button>
                  <Link
                    to={`/category/${item?.category ? generateSlug(item?.category) : "-"
                      }/${generateSlug(item?.title)}/${generateSlug(item?._id)}`}
                    state={{ item }}
                    className="block no-underline"
                  >
                    <div>
                      <h2 className="sm:text-xl text-xs text-black sm:mt-0 mt-3">
                        {item.name}
                      </h2>
                      <h2 className="text-black text-sm md:text-base line-clamp-1 font-bold leading-none mb-1">
                        {item.title}
                      </h2>
                      <div>
                        <span className={CustomeStyle.description}>
                          {item.description}
                        </span>
                      </div>
                      <div className="mt-2 flex justify-between items-center me-2">
                        <div className={`${CustomeStyle.row} space-x-1`}>
                          <span className={CustomeStyle.text}>
                            ₹{item.salePrice}
                          </span>
                          <span
                            className={CustomeStyle.text}
                            style={{ textDecoration: "line-through" }}
                          >
                            ₹{item.regularPrice}
                          </span>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              ))
            ) : (
              <div className="flex justify-center items-center h-[200px] w-full sm:ms-96 ms-20">
                <p className="text-center text-lg font-semibold">
                  No Product Found
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default ShowSubCategory;
